<template>
    <!--
    <p><strong>Current route path:</strong> {{ $route.fullPath }}</p>
    -->
    <main>
        <RouterView />
    </main>
</template>


<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.logo {
    width: auto;
    height: 200px;
}
</style>
